import React from 'react'
import SettingApiForm from '../components/setting/settingApiForm'

const SettingsSeo = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingsSeo